$.fn.lib_reCaptcha = function(attr) {
    var elm = $(this);
    var recaptchaUrl = 'https://www.google.com/recaptcha/api.js?render={apikey}';
    if(elm.length) {
        $.getScript(recaptchaUrl.replace("{apikey}",elm.data(attr))).done(function(){
            grecaptcha.ready(function() {
                grecaptcha.execute(elm.data(attr), {action: 'form'}).then(function(token) {
                    elm.find('[name="gtoken"]').val(token);
                });
            });
        })
    }
};